import { api } from './api';

export interface CourseReschedulePayload {
  mode: 'einmalig' | 'dauerhaft';
  courseId: number;
  unitId?: number | null;
  instanceDate: string; // YYYY-MM-DD
  newDate: string; // YYYY-MM-DD
  newStartTime: string; // HH:MM
  newEndTime: string; // HH:MM
  newRoomId?: number | null;
  historyText?: string;
  historyTemplateKey?: string;
  courseName?: string;
}

export interface CourseRescheduleResult {
  ok: boolean;
  mode: 'einmalig' | 'dauerhaft';
  overrideId?: number;
  unitId?: number | null;
  ruleId?: number;
  historyId?: number;
}

export const courseRescheduleApi = {
  reschedule: async (payload: CourseReschedulePayload): Promise<CourseRescheduleResult> => {
    return api.post<CourseRescheduleResult>('/api/course-reschedule', payload);
  },
};
